import {Injectable} from "@angular/core";
import {AbstractContactVO} from "@well/domain";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {NotifiableContactResourceService} from "../common/notifiable-contact-resource.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DelNotifiableContactResourceService extends NotifiableContactResourceService{
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('delNotifiableContactUrl'),
      undefined,
      undefined
    );
  }

  getNotifiableContactsForEntityUuid(entityUuid): Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/${entityUuid}`);
  }

  getAvailableNotifiableContactsForEntityUuid(entityUuid): Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/available/${entityUuid}`);
  }

  getNotifiableContactsForEntityUuids(entityUuids): Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.get(`${this.url}/list/${entityUuids}`);
  }

  updateNotifiableContactsForEntityUuid(entityUuid: string, contactUuids: string[]): Observable<AbstractContactVO[]> {
    return <Observable<AbstractContactVO[]>>this.httpClient?.post(`${this.url}/update/${entityUuid}`, contactUuids);
  }

}
